
import { defineComponent, defineAsyncComponent } from 'vue'

const HeroMTShop = defineAsyncComponent(() =>
  import('@/components/mt-shop-parts/Hero.vue'),
)
const ServicesContactForm = defineAsyncComponent(() =>
  import('@/components/components-services/ServicesContactForm.vue'),
)
const ServicesFooter = defineAsyncComponent(() =>
  import('@/components/components-services/ServicesFooter.vue'),
)

const AdvantagesSection = defineAsyncComponent(() =>
  import('@/components/mt-shop-parts/AdvantagesSection.vue'),
)
const GoodsSection = defineAsyncComponent(() =>
  import('@/components/mt-shop-parts/GoodsSection.vue'),
)

export default defineComponent({
  name: 'MTShopView',
  components: {
    HeroMTShop,
    AdvantagesSection,
    GoodsSection,
    ServicesContactForm,
    ServicesFooter,
  },
})
